export default "__VITE_ASSET__CcjJ5wzS__"